<template>
    <div>
        <div v-if="formSubmissionSucceeded" 
            class="alert alert-success" 
            style="margin: 0;"
            role="alert"
        >
            Votre demande de signature électronique a bien été prise en compte.<br>
            Un mail vient d'être envoyé au client afin de procéder à la signature du document.
        </div>

        <div v-else>
            <div v-if="displayGlobalError" 
                class="alert alert-danger" 
                role="alert"
            >
                {{ globalErrorMessage }}
            </div>

            <p>
                Renseignez les informations suivantes afin de démarrer le processus de signature électronique du contrat. 
                <strong>Un numéro de téléphone mobile valide est indispensable afin de finaliser le processus.</strong>
            </p>

            <div v-if="customerSignatories.length > 0" class="form-group">
                <label for="signatory_id">Quel signataire souhaitez-vous utiliser ?</label>

                <select id="signatory_id" class="form-control" v-model="signatoryId">
                    <option v-for="(option, index) in signatoryIdOptions" :key="index" :value="option.key">{{ option.value }}</option>
                </select>

                <p v-if="hasError('signatory_id')" class="text-danger">
                    {{ getError('signatory_id') }}
                </p>
            </div>

            <div v-if="'new' == signatoryType">
                <div class="form-group">
                    <label for="first_name">Prénom</label>
                    
                    <input type="text" id="first_name" 
                        class="form-control" 
                        v-model="firstName"
                        disabled
                    >

                    <p v-if="hasError('first_name')" class="text-danger">
                        {{ getError('first_name') }}
                    </p>
                </div>

                <div class="form-group">
                    <label for="last_name">Nom</label>
                    
                    <input type="text" id="last_name" 
                        class="form-control" 
                        v-model="lastName"
                        disabled
                    >

                    <p v-if="hasError('last_name')" class="text-danger">
                        {{ getError('last_name') }}
                    </p>
                </div>

                <div class="form-group">
                    <label for="email">E-mail</label>
                    
                    <input type="email" id="email" 
                        class="form-control" 
                        v-model="email"
                    >

                    <p v-if="hasError('email')" class="text-danger">
                        {{ getError('email') }}
                    </p>
                </div>

                <div class="form-group">
                    <label for="mobile_phone">Téléphone mobile</label>

                    <input type="text" id="mobile_phone"
                        class="form-control"
                        placeholder="+33612345678"
                        v-model="mobilePhone"
                    >

                    <small class="form-text text-muted">Format international, ex : +33612345678</small>

                    <p v-if="hasError('mobile_phone')" class="text-danger">
                        {{ getError('mobile_phone') }}
                    </p>
                </div>

                <div class="form-group" style="background-color: #e1e1e1; padding: 10px;">
                    <label for="representative_acting_user" style="text-transform: none; font-size: 14px; font-weight: 400;">
                        <input type="radio" id="representative_acting_user" 
                            value="representative" 
                            class="input mr-1"
                            v-model="actingUser"
                        >

                        En cochant cette case, je certifie être le représentant légal, et je certifie l'exactitude des informations ci-dessus
                    </label>

                    <label for="third_party_acting_user" style="text-transform: none; font-size: 14px; font-weight: 400;">
                        <input type="radio" id="third_party_acting_user" 
                            value="third_party" 
                            class="input mr-1"
                            v-model="actingUser"
                        >
                        
                        En cochant cette case, je certifie avoir reçu un pouvoir et agir pour le compte du représentant légal, 
                        je saisis donc mon email et mon numéro de téléphone, et je certifie l'exactitude des informations ci-dessus
                    </label>

                    <p v-if="hasError('acting_user')" class="text-danger">
                        {{ getError('acting_user') }}
                    </p>
                </div>
            </div>

            <div style="margin-top: 20px;">
                <button @click="submit" class="btn btn-primary btn-sm">Valider</button>
                <button @click="cancel" class="btn btn-default btn-sm">Annuler</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { map as _map } from 'lodash'
    import formErrorsMixin from 'mixins/simpleFormErrors'

    export default {
        data() {
            return {
                formSubmissionSucceeded: false,
                customerSignatories: [],
                customerMainRepresentative: null,
                displayGlobalError: false,
                globalErrorMessage: null,
                signatoryId: null,
                firstName: null,
                lastName: null,
                mobilePhone: null,
                email: null,
                actingUser: null
            }
        },

        props: {
            contractId: {
                type: Number,
                required: true
            },
            customerId: {
                type: Number,
                required: true
            }
        },

        mixins: [formErrorsMixin],

        mounted() {
            this.$emit('loading')

            this.getCustomerMainRepresentative()
                .then(() => {
                    this.setDefaultValues()
                    this.$emit('loaded')
                })

            // this.getCustomerSignatories()
            //     .then(() => {
            //         this.setDefaultSignatoryId()
            //         this.$emit('loaded')
            //     })
        },

        computed: {
            formattedSignatories() {
                if (!this.customerSignatories.length) {
                    return this.customerSignatories
                }

                return _map(this.customerSignatories, signatory => {
                    return {
                        key: signatory.id,
                        value: `${signatory.first_name} ${signatory.last_name} (${signatory.email} / ${signatory.mobile_phone})`
                    }
                })
            },
            signatoryIdOptions() {
                return this.formattedSignatories.concat([{key: 0, value: 'Nouveau signataire'}])
            },
            signatoryType() {
                if (this.signatoryId === 0) {
                    return 'new'
                } else if (this.signatoryId) {
                    return 'existing'
                }

                return null
            }
        },

        methods: {
            getCustomerMainRepresentative() {
                return this.axios
                    .get(`customers/${this.customerId}/representatives/main`)
                    .then(response => {
                        this.customerMainRepresentative = response.data.representative;
                    })
            },
            setDefaultValues() {
                if (this.customerMainRepresentative) {
                    this.firstName = this.customerMainRepresentative.person.first_name
                    this.lastName = this.customerMainRepresentative.person.last_name
                    this.email = this.customerMainRepresentative.person.email
                    this.mobilePhone = this.customerMainRepresentative.person.mobile_phone
                }
                this.signatoryId = 0
            },
            // getCustomerSignatories() {
            //     return this.axios
            //         .get(`customers/${this.customerId}/signatories?paginate=0`)
            //         .then(response => {
            //             this.customerSignatories = response.data.signatories;
            //         })
            // },
            // setDefaultSignatoryId() {
            //     if (this.customerSignatories.length > 0) {
            //         this.signatoryId = this.customerSignatories[0].id
            //     } else {
            //         this.signatoryId = 0
            //     }
            // },
            resetAllErrors() {
                this.resetErrors()
                this.globalErrorMessage = null
                this.displayGlobalError = false
            },
            submit() {
                this.resetAllErrors()
                this.$emit('loading')

                if (!this.signatoryId && this.signatoryId !== 0) {
                    this.globalErrorMessage = 'Merci de sélectionner un signataire'
                    this.displayGlobalError = true
                    this.$emit('loaded')
                } else {
                    const defaultPayload = {
                        signatory_type: this.signatoryType
                    }

                    const variablePayload = 'existing' == this.signatoryType 
                        ? { signatory_id: this.signatoryId, acting_user: this.actingUser }
                        : { first_name: this.firstName, last_name: this.lastName, email: this.email, mobile_phone: this.mobilePhone, acting_user: this.actingUser }

                    const payload = { ...defaultPayload, ...variablePayload }

                    this.axios
                        .post(`contracts/${this.contractId}/digital_contracts`, payload)
                        .then(response => {
                            this.formSubmissionSucceeded = true
                            this.$emit('accepted')
                        })
                        .catch(error => {
                            if (error.hasOwnProperty('response') && error.response.hasOwnProperty('data')) {
                                if (error.response.data.hasOwnProperty('errors')) {
                                    this.setErrors(error.response.data.errors)
                                } else if (error.response.data.hasOwnProperty('message')) {
                                    this.globalErrorMessage = error.response.data.message
                                    this.displayGlobalError = true
                                }
                            }
                        })
                        .then(() => this.$emit('loaded'))
                }
            },
            cancel() {
                this.$emit('cancelled')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .spinner-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.25);

        .spinner {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .alert.alert-success {
        background-color: #dff0d8;
        color: #3c763d;
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature/SignForm.vue